import React from "react";
import "../styles/App.css";

function Hero() {
  return (
    <section className="hero contact-bgImage">
      <h1>Hi, I'm <span className="highlight">Sarthak Bhojane</span></h1>
      <p>Full Stack Developer | Java | MERN | Cloud | Flutter</p>
     
      <div className="hero-buttons">
      <a href="#contact" className="btn">Get in Touch</a>
      <a href="#projects" className="btn">View Projects</a>
    </div>
    
    
    </section>
  );
}

export default Hero;
